import { UnitSystem } from '../types/unit-system';

const KM_PER_MILE = 1.60934;
const METERS_PER_FOOT = 0.3048;
const FEET_PER_METER = 3.28084;
const FAHRENHEIT_FREEZING_POINT = 32;
const FAHRENHEIT_TO_CELSIUS_RATIO = 5 / 9;
const CELSIUS_TO_FAHRENHEIT_RATIO = 9 / 5;

export class UnitConverter {
  static convertTemperature(value: number, fromSystem: UnitSystem, toSystem: UnitSystem): number {
    if (fromSystem === toSystem) return value;
    return fromSystem === 'imperial'
      ? (value - FAHRENHEIT_FREEZING_POINT) * FAHRENHEIT_TO_CELSIUS_RATIO
      : value * CELSIUS_TO_FAHRENHEIT_RATIO + FAHRENHEIT_FREEZING_POINT;
  }

  static convertMilesToKilometers(value: number, fromSystem: UnitSystem, toSystem: UnitSystem): number {
    if (fromSystem === toSystem) return value;
    return fromSystem === 'imperial' ? value * KM_PER_MILE : value / KM_PER_MILE;
  }

  static convertAltitude(value: number, fromSystem: UnitSystem, toSystem: UnitSystem): number {
    if (fromSystem === toSystem) return value;
    return fromSystem === 'imperial' ? value * METERS_PER_FOOT : value * FEET_PER_METER;
  }
}

